/**
 * The shared page header.
 *
 * Carries no padding: the shell's `<main>` owns page gutters. The previous
 * `pb-section pt-page-x` was never declared in `@theme`, so both resolved to
 * nothing — as did `text-caption` and `text-page`, which silently dropped the
 * title to 16px (the inherited body size) and the caption to 16px too. These
 * now use real steps from the one text scale.
 */
export const pageHeaderClasses = 'flex flex-col gap-2';

export const breadcrumbListClasses = 'flex items-center gap-1 text-xs text-content-muted';

export const breadcrumbItemClasses = 'hover:text-content';

export const breadcrumbSeparatorClasses = 'text-content-muted';

export const pageHeaderRowClasses = 'flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-start sm:justify-between sm:gap-2';

export const pageTitleClasses = 'text-2xl font-semibold text-content';

export const pageDescriptionClasses = 'text-xs text-content-muted';

export const pageHeaderActionsClasses = 'flex flex-wrap items-center gap-2';
